<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import { Mic, MicOff, PhoneOff } from 'lucide-svelte';
  import ControlButton from '../molecules/ControlButton.svelte';

  interface Props {
    muted: boolean;
    disabled?: boolean;
    onToggleMute?: () => void;
    onLeave?: () => void;
  }

  let { muted, disabled = false, onToggleMute, onLeave }: Props = $props();
</script>

<div class="fixed bottom-6 left-0 right-0 flex justify-center px-4 z-20">
  <div
    class="backdrop-blur-xl bg-slate-900/90 border border-white/10 rounded-full shadow-2xl px-2 py-2 flex items-center gap-2"
  >
    <ControlButton
      variant={muted ? 'unmute' : 'mute'}
      {disabled}
      ariaLabel={muted ? 'Включить микрофон' : 'Выключить микрофон'}
      onclick={onToggleMute}
    >
      {#if muted}
        <MicOff class="w-5 h-5 text-white" />
      {:else}
        <Mic class="w-5 h-5 text-white" />
      {/if}
    </ControlButton>
    <ControlButton variant="leave" ariaLabel="Покинуть комнату" onclick={onLeave}>
      <PhoneOff class="w-5 h-5 text-white" />
    </ControlButton>
  </div>
</div>
